/**
 * @author: lv.chen
 * @date: 2025/12/31
 * @desc: 单个GRC报告卡片组件
 */
import React from 'react';
import Bubble from '@home/components/TeaComponents/Bubble';
import CreatorBox from '@intelligence/components/ReportCard/CreatorBox';
import { buildReportAuthors } from '@intelligence/components/ReportCard/authors';
import useBubbleVisible from './_hooks/useBubbleVisible';

interface IGrcReportCardProps extends IBaseProps {
  report: IGRCReportItem | null;
  onGoToReportDetails?: (report: IGRCReportItem | null) => void;
}

const GrcReportCard: React.FC<IGrcReportCardProps> = (props) => {
  const { report, onGoToReportDetails } = props;
  const authors = buildReportAuthors(report || {});

  const {
    visible: outerVisible,
    onMouseEnter: onOuterMouseEnter,
    onMouseLeave: onOuterMouseLeave,
    onMouseMove: onOuterMouseMove,
  } = useBubbleVisible();

  const {
    visible: innerVisible,
    onMouseEnter: onInnerMouseEnter,
    onMouseLeave: onInnerMouseLeave,
    onMouseMove: onInnerMouseMove,
  } = useBubbleVisible();

  // 内层气泡hover时，隐藏外层气泡
  const handleInnerMouseEnter = (e?: React.MouseEvent<HTMLDivElement>) => {
    if (outerVisible) {
      onOuterMouseLeave?.();
    }
    onInnerMouseEnter?.(e);
  };

  const handleInnerMouseLeave = (e?: React.MouseEvent<HTMLDivElement>) => {
    onInnerMouseLeave?.(e);
    // 离开内层时，恢复外层气泡（因为鼠标还在外层card内）
    if (!outerVisible) {
      onOuterMouseEnter?.();
    }
  };

  return (
    <Bubble key={report?.resource_id} content="点击报告可下钻查看报告详情" visible={outerVisible}>
      <div
        className="dbi-grc-item-card"
        onMouseEnter={onOuterMouseEnter}
        onMouseLeave={onOuterMouseLeave}
        onMouseMove={onOuterMouseMove}
        onClick={(e) => {
          e.stopPropagation();
          onGoToReportDetails?.(report);
        }}
      >
        <div className="dbi-grc-item-figure">
          <div className="dbi-grc-item-card-img">
            <img src={report?.cover} className="dbi-grc-item-cover" alt="" />
          </div>
          <div className="dbi-grc-item-content">
            <h3 className="dbi-grc-item-title">{report?.title_cn}</h3>
            <Bubble content={report?.abstract_cn} visible={innerVisible}>
              <div
                className="dbi-grc-item-desc"
                onMouseOver={handleInnerMouseEnter}
                onMouseEnter={handleInnerMouseEnter}
                onMouseLeave={handleInnerMouseLeave}
                onMouseMove={onInnerMouseMove}
              >
                {report?.abstract_cn}
              </div>
            </Bubble>
            <div className="dbi-grc-item-meta">
              <span className="dbi-grc-item-meta-time">{report?.create_time}</span>
              {report?.tag_cn_list?.map((tag) => (
                <span key={tag} className="dbi-grc-item-tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="dbi-grc-item-author">
          <CreatorBox authors={authors} lang={0} />
        </div>
      </div>
    </Bubble>
  );
};

export default GrcReportCard;
